/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ChartOfAccountResponse | undefined,
  (params: vp.GetChartOfAccountRequest) => void,
  (params: vp.GetChartOfAccountRequest) => Promise<vp.ChartOfAccountResponse>,
  () => void,
];

function useFetchRailzAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.GetChartOfAccountRequest>();
  const [response, setResponse] = useState<vp.ChartOfAccountResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.GetChartOfAccountRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchRailzAccount(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.GetChartOfAccountRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.GetChartOfAccountRequest) => {
      const res = api.fetchRailzAccount(requestParams, source);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchRailzAccount);
